import React from "react";
import { formatToINR } from "../../../../helpers/utility";
import styles from "./BillingIp.module.css";

const TotalAmountPaid = ({ paymentData }) => {
  const totalPaid = Number(paymentData?.total_paid_amount || 0);
  const totalBill = Number(paymentData?.total_amount || 0);
  const progress = totalBill > 0 ? Math.min((totalPaid / totalBill) * 100, 100) : 0;

  const marker25 = totalBill > 0 ? Math.round(totalBill * 0.25) : 0;
  const marker75 = totalBill > 0 ? Math.round(totalBill * 0.75) : 0;

  return (
    <section className={styles.paidCard}>
      <p className={styles.paidLabel}>Total amount paid</p>
      <p className={styles.paidAmount}>{formatToINR(totalPaid)}</p>
      <div className={styles.paidProgressBlock}>
        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
        <div className={styles.progressLabels}>
          <span>{formatToINR(marker25)}</span>
          <span>{formatToINR(marker75)}</span>
          <span className={styles.progressTotal}>Tot. {formatToINR(totalBill)}</span>
        </div>
      </div>
    </section>
  );
};

export default TotalAmountPaid;
